module.exports = __webpack_public_path__ + "static/media/day25.workshop.9e679564.md";